import loadable from 'Components/AsyncModuleLoader/AsyncModuleLoader';
import loading from 'Components/asyncLoading/asyncLoading';
import React from 'react';
const Loading = loading();

export default loadable({
    loader: () => import(/* webpackChunkName: "gallery-overlay" */'./GalleryNavOverlay.APP_TARGET'),
    loading: <Loading />
});
